
import { defineComponent, computed, ref, inject, watchEffect } from 'vue'
import RecipeStore, { CollectionMealType } from '@/store'

import MealModal from '@/components/recipe/MealModal.vue'
import Pagination from './Pagination.vue'
import CardSkeleton from '@/components/recipe/Search/CardSkeleton.vue'
import Donate from '@/components/recipe/Search/Donate.vue'

import HeartIcon from '@/components/UI/Icon/Heart.vue'
import StarIcon from '@/components/UI/Icon/Star.vue'

import { useI18n } from 'vue-i18n'

export default defineComponent({
  components: {
    MealModal,
    StarIcon,
    Pagination,
    CardSkeleton,
    Donate,
    HeartIcon
  },
  inject: ['store'],
  setup () {
    const { t } = useI18n()
    const store = inject('store', RecipeStore)

    const getMeals = computed(() => store.getters.getMeals)
    // const isLoading = computed(() => store.getters.getDataIsLoading)

    /** Modal controal */
    const modalStatus = ref(false)
    const mealId = ref('')

    function onModalOpen (id: string) {
      modalStatus.value = true
      mealId.value = id
      document.body.style.overflow = 'hidden'
    }

    function onModalClose () {
      modalStatus.value = !modalStatus.value
      document.body.style.overflow = 'auto'
    }
    const isModalOpen = computed(() => {
      return modalStatus.value
    })

    /** Pagnation */
    const currentPage = ref(1)
    const onePageMealsCount = 6

    function changePage (page: number) {
      currentPage.value = page
    }

    /** Collection */
    function handleCollection (meal: CollectionMealType) {
      store.ADD_COLLECTED_RECIPE(meal)
    }

    const handlePageMeals = computed(() => {
      return getMeals.value.filter((_, index) => {
        if (currentPage.value === 1) {
          return index < onePageMealsCount * currentPage.value
        } else {
          return (
            index >= onePageMealsCount * (currentPage.value - 1) &&
            index < onePageMealsCount * currentPage.value
          )
        }
      })
    })

    /** Card skeleton */
    const isEmpty = ref(true)
    const isSearched = computed(() => store.getters.getSearchName)

    watchEffect(() => {
      isEmpty.value = !(getMeals.value && getMeals.value.length !== 0)
      currentPage.value = isSearched.value ? 1 : currentPage.value
    })

    return {
      t,
      getMeals,
      isModalOpen,
      onModalOpen,
      onModalClose,
      mealId,
      changePage,
      handlePageMeals,
      isEmpty,
      handleCollection
    }
  }
})
